

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

// Components
import Btn, { BtnColor, BtnWidth, BtnHeight, BtnFontSize, BtnPredefinedStyle } from '@/shared/components/btn.component.vue';
import SpotlightText, { SpotlightTextColor } from '@/shared/components/SpotlightText.component.vue';

// Vies
import Summary from '@/client/budget/views/acceptance/summary/index.vue';
import DownloadView from '@/client/budget/views/acceptance/download-view/index.vue';
import InfoView from '@/client/budget/views/acceptance/info-view/index.vue';

// Models
import { Budget, BudgetCommunicationStatus } from '@/manager/budget/models/budget.model';


@Component({
    components: {
        Btn,
        InfoView,
        Summary,
        SpotlightText,
        DownloadView,
    },
    computed: {
        ...mapGetters({
            currentBudget: 'getCurrentBudgetAcceptance',
            hasServerError: 'hasServerError',
            getServerError: 'getServerError',
            budgetIsExpired: 'currentBudgetAcceptanceIsExpired',
        }),
    },
    methods: {
        ...mapActions({
            validateBudget: 'validateBudgetAcceptance',
            fetchBudgetProducts: 'fetchBudgetProducts',
        }),
    },
})
export default class AcceptanceValidation extends Vue {
    @Prop() private id!: string;


    private currentBudget!: any;
    private validateBudget!: any;
    private fetchBudgetProducts!: any;
    private budgetIsExpired!: any;
    private spotlightTextColor = SpotlightTextColor;
    private btnColor = BtnColor;
    private btnWidth = BtnWidth;
    private btnHeight = BtnHeight;
    private btnFontSize = BtnFontSize;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private literals = {
        btn: 'Validar',
        downloadView: {
            title: 'Validación de alta completada!',
            subtitle: 'Enhorabuena, has finalizado con éxito el proceso de validación de alta. ' +
                'Puedes descargar el documento con el resumen de tu alta pinchando en el siguiente enlace:',
        },
    };


    private created() {
        this.initializeComponent();
    }


    get showSummary() {
        return this.currentBudget.communicationStatus === BudgetCommunicationStatus.Adjust;
    }

    get showDownloadView() {
        return this.currentBudget.communicationStatus === BudgetCommunicationStatus.Accepted;
    }

    get showInfoView() {
        return (
            this.currentBudget.communicationStatus === BudgetCommunicationStatus.Rejected ||
            this.currentBudget.communicationStatus === BudgetCommunicationStatus.Pending ||
            this.currentBudget.communicationStatus === BudgetCommunicationStatus.Dispatched ||
            ( this.budgetIsExpired && !this.showDownloadView )
        );
    }


    private async initializeComponent() {
        await this.fetchBudgetProducts({ id: this.id });
        this.fetchBudgetValidate();
    }

    private validateBudgetAcceptance() {
        this.validateBudget({ id: this.id }).then(
            (res: any) => {
                this.currentBudget.communicationStatus = BudgetCommunicationStatus.Accepted;
                this.$store.dispatch('setCurrentBudgetAcceptance', this.currentBudget);
            },
        );
    }

    private fetchBudgetValidate() {
        return this.$store.dispatch('fetchBudgetValidate', { id: this.id });
    }
}
